<template>
  <div>
    <PersonalTypeSelector/>
    <ProfileList/>
    <UserInfo/>
    <Delivery/>
    <Payments/>
    <Price/>
    <ErrorMessage
      v-if="getGlobalErrors.length > 0"
      :errors="errors"
      :class-list="['order-global-errors']"/>
    <ExecuteOrder/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import PersonalTypeSelector from './PersonalTypeSelector'
  import ProfileList from './ProfileList'
  import UserInfo from './UserInfo/UserInfo'
  import Payments from './Payments'
  import Price from './Price'
  import ExecuteOrder from './ExecuteOrder'
  import Delivery from './Delivery'
  import ErrorMessage from './ErrorMessage'
  import reduce from 'lodash/reduce'

  export default {
    name: 'Order',
    components: {
      PersonalTypeSelector,
      ProfileList,
      UserInfo,
      Delivery,
      Payments,
      Price,
      ExecuteOrder,
      ErrorMessage
    },
    computed: {
      ...mapGetters('order', [
        'getGlobalErrors'
      ]),
      errors: function () {
        return reduce(this.getGlobalErrors, (r, e) => {
          r.push(`<div>Ошибка оформления заказа: <b>${e}</b></div>`)
          return r
        }, [])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Order.vue